export default {
  create: {
    success: 'Utilisateur Wiztrust créé avec succès',
    error: "Impossible de créer l'utilisateur Wiztrust"
  },
  update: {
    success: "La modification de l'utilisateur Wiztrust a été effectuée avec succès",
    error: "Impossible de modifier l'utilisateur Wiztrust"
  },
  delete: {
    success: 'Utilisateur Wiztrust supprimé avec succès',
    error: "Impossible de supprimer l'utilisateur Wiztrust"
  }
}
